import { useContext, useEffect, useRef,useState } from "react";
import { CInputText, CInputPassword, BtnLoader, PageLoader, toast } from "../../components/widget";
import { Link, useNavigate,useLocation,useSearchParams } from 'react-router-dom';
import { RegisterApi } from "../../api";
import { ContextLoading } from "../../context";

export const Register = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const formRef: any = useRef();
    const CtxLoad = useContext(ContextLoading);
    const [searchParams] = useSearchParams();

    let refValue: string;  // متغیر را خارج از شرط تعریف کنید

    if (searchParams.get('ref') != null) {
        refValue = searchParams.get('ref')!;
    } else {
        refValue = "dayan.app";
    }


    const handelRegister = async (e: any) => {
        e.preventDefault();
        if(formRef.current['password'].value != formRef.current['password2'].value) return toast("رمز عبور و تکرار آن مطابقت ندارند", { type: "error" });
        CtxLoad.setDisplayLoadingBtn(true);
        let res:any = await RegisterApi(formRef);
        CtxLoad.setDisplayLoadingBtn(false);
        if (res.data.success) {
            toast(res.data.message, { type: "success" , autoClose:6000 });
            navigate('/');
        }
        else {
            toast(res.data.message, { type: "error" });
        }
    }

    useEffect(() => {
        document.title = "ثبت نام | دایان";
    }, []);

    return (
        <>
            {CtxLoad.displayLoading && <PageLoader />}
            <div className=" w-full min-h-screen bg-dayan-gray-50 flex justify-center items-center">
                <div className="w-full sm:w-[400px]  flex flex-col items-center">
                    <img src="/assetes/logo/logo.png" alt="logo" className=" w-[120px]" />
                    <div className=" w-[94%] sm:w-full mt-[10px] flex flex-col items-center justify-center rounded-xl shadow bg-white py-[30px] px-[20px]">
                        <form ref={formRef} onSubmit={handelRegister} className=" w-full ">
                            <CInputText  name="name" title="نام شرکت" type="text" required={true} />
                            <CInputText custom_class="Cltr" name="email" title="پست الکترونیکی" type="email" required={true} />
                            <CInputText custom_class="Cltr" name="mobile" title="شماره موبایل" type="number" required={true} />
                            <CInputPassword custom_class="Cltr" name="password" title="رمز عبور" required={true} />
                            <CInputPassword custom_class="Cltr" name="password2" title="تکرار رمز عبور" required={true} />

                            <CInputText custom_class="Cltr" name="referer" title="کد معرف" type="text" required={false} value={refValue} />


                            {CtxLoad.displayLoadingBtn ?
                                <button type="button" className=" w-full h-[40px] sm:h-[45px] text-white text-xs font-bold rounded-[5px] bg-dayan-gray-100 flex justify-center items-center cursor-not-allowed"><BtnLoader /></button>
                                :
                                <button type="submit" className=" w-full h-[40px] sm:h-[45px] text-white text-xs font-bold rounded-[5px] bg-dayan-gray-100">ثبت نام</button>
                            }
                        </form>
                        <Link to={'/'} className="mt-[20px]">
                            <span className=" text-dayan-gray-100 text-sm cursor-pointer mt-[20px]">حساب کاربری دارید ؟</span>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
}
